import {
  getOrders,
  getOrderById,
  createOrder,
  updateOrderStatus,
  deleteOrder,
} from "./asyncThunks";

export const getOrdersBuilder = (builder) => {
  builder.addCase(getOrders.pending, (state) => {
    state.orders.loading = true;
    state.orders.error = null;
  });
  builder.addCase(getOrders.fulfilled, (state, { payload }) => {
    const {
      data,
      pagination,
      totalRevenue,
      thisMonthRevenue,
      lastMonthRevenue,
    } = payload;
    state.orders.data = data;
    state.orders.pagination = pagination;
    state.orders.totalRevenue = totalRevenue;
    state.orders.thisMonthRevenue = thisMonthRevenue;
    state.orders.lastMonthRevenue = lastMonthRevenue;
    state.orders.loading = false;
  });
  builder.addCase(getOrders.rejected, (state, action) => {
    state.orders.loading = false;
    state.orders.error = action.error.message;
  });
};

export const getOrderByIdBuilder = (builder) => {
  builder.addCase(getOrderById.pending, (state) => {
    state.orderById.loading = true;
    state.orderById.error = null;
  });
  builder.addCase(getOrderById.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.orderById.data = data;
    state.orderById.loading = false;
  });
  builder.addCase(getOrderById.rejected, (state, action) => {
    state.orderById.loading = false;
    state.orderById.error = action.error.message;
  });
};

export const createOrderBuilder = (builder) => {
  builder.addCase(createOrder.pending, (state) => {
    state.orders.createLoading = true;
    state.orders.error = null;
  });
  builder.addCase(createOrder.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.orders.data = [data, ...state.orders.data]; // Dodaj na početak liste
    state.orders.createLoading = false;
    state.orders.createSuccess = true;
  });
  builder.addCase(createOrder.rejected, (state, action) => {
    state.orders.createLoading = false;
    state.orders.error = action.error.message;
  });
};

export const updateOrderStatusBuilder = (builder) => {
  builder.addCase(updateOrderStatus.pending, (state) => {
    state.orders.updateLoading = true;
    state.orders.error = null;
  });
  builder.addCase(updateOrderStatus.fulfilled, (state, { payload }) => {
    const { data } = payload;
    // Ažuriraj order u listi
    state.orders.data = state.orders.data.map((order) =>
      order.id === data.id ? { ...order, status: data.status } : order
    );
    // Ažuriraj i u orderById ako je učitan
    if (state.orderById.data && state.orderById.data.id === data.id) {
      state.orderById.data = { ...state.orderById.data, status: data.status };
    }
    state.orders.updateLoading = false;
  });
  builder.addCase(updateOrderStatus.rejected, (state, action) => {
    state.orders.updateLoading = false;
    state.orders.error = action.error.message;
  });
};

export const deleteOrderBuilder = (builder) => {
  builder.addCase(deleteOrder.pending, (state) => {
    state.orders.deleteLoading = true;
    state.orders.error = null;
  });
  builder.addCase(deleteOrder.fulfilled, (state, { payload }) => {
    const { data } = payload;
    // Ukloni order iz liste
    state.orders.data = state.orders.data.filter(
      (order) => order.id !== data.id
    );
    // Očisti orderById ako je obrisan order učitan
    if (state.orderById.data && state.orderById.data.id === data.id) {
      state.orderById.data = null;
    }
    state.orders.deleteLoading = false;
  });
  builder.addCase(deleteOrder.rejected, (state, action) => {
    state.orders.deleteLoading = false;
    state.orders.error = action.error.message;
  });
};
